import pako from "pako";

export function compressAndSerializeData<T>(data: T): string {
  const json = JSON.stringify(data);
  const compressed = pako.deflate(json);
  const binaryString = Array.from(compressed)
    .map((byte) => String.fromCharCode(byte))
    .join("");
  return btoa(binaryString);
}

export function decompressAndDeserializeData<T>(data: string): T {
  if (!data) {
    throw new Error("Data cannot be null or undefined");
  }

  if (isBase64Encoded(data)) {
    try {
      const binaryString = atob(data);
      const compressedBytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        compressedBytes[i] = binaryString.charCodeAt(i);
      }
      const decompressed = pako.inflate(compressedBytes, { to: "string" });
      return JSON.parse(decompressed);
    } catch (error) {
      throw new Error(
        `Failed to decompress data: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  } else {
    try {
      return JSON.parse(data);
    } catch (error) {
      throw new Error(
        `Failed to deserialize uncompressed data: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  }
}

function isBase64Encoded(data: string): boolean {
  return (
    data != null &&
    data.trim().length > 0 &&
    /^[A-Za-z0-9+/]*={0,2}$/.test(data) &&
    data.length % 4 === 0 &&
    !data.trim().startsWith("{")
  );
}
